import React from 'react';
import { Label } from '../../../../../../../common/labels/labelTypes';
import { TagBase } from '@milanote/roma';
import Icon from '../../../../../../components/icons/Icon';
import Button from '../../../../../../components/buttons/Button';

type Props = {
    label: Label;
    handleClickLabel: (label: Label) => void;
    handleClickEdit: (label: Label) => void;
    isSelected?: boolean;
    size: 'xs' | 'sm' | 'md' | 'lg' | undefined;
};

const LabelListElement: React.FC<Props> = ({ label, handleClickLabel, handleClickEdit, isSelected, size }) => {
    const { id, name, color } = label;

    return (
        <div id={`label-${id}`} className="LabelListElement mb-1 w-full flex items-center justify-between">
            <div className="cursor-pointer" onClick={() => handleClickLabel(label)}>
                <TagBase size={size} color={color}>
                    {name}
                </TagBase>
            </div>
            <div className="flex gap-1">
                {isSelected && <Icon name="block-style-tick" />}
                <Button onClick={() => handleClickEdit(label)}>...</Button>
            </div>
        </div>
    );
};

export default LabelListElement;
